import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { ROUTER_PATHS, gridSizeMdLg8, newRadioBaseSchema} from '@/shared';
import { useCreateRadioBase,useUpdateRadioBase } from '@/shared/actions/erp';
import {
  CustomTextField,
  ModelStateSelect,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { RadioBase } from '@/shared/interfaces/erp/mantenimiento-operaciones';
import {Grid } from '@mui/material';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';

const returnUrlRadioBase = ROUTER_PATHS.mantenimientoOperaciones.radioBasesNav;
export interface SaveRadioBaseInterface {
  titlePage: string;
  editRadioBase?: RadioBase;
  enableUploadFile?: boolean;
}

type SaveFormData = {
  nombre: string;
  codigo?: string;
  direccion: string;
  coordenadas: string;
  estado: boolean;
};

const SaveRadioBase: React.FC<SaveRadioBaseInterface> = ({
  titlePage,
  editRadioBase,
}) => {

  const setAlert = useUiStore(s => s.setAlert);

  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createRadioBaseMutation = useCreateRadioBase({ navigate, returnUrl: returnUrlRadioBase });
  const updateRadioBaseMutation = useUpdateRadioBase({ navigate, returnUrl: returnUrlRadioBase });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newRadioBaseSchema),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editRadioBase?.id_radiobase) {
      return updateRadioBaseMutation.mutate({
        id: editRadioBase.id_radiobase,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createRadioBaseMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editRadioBase) {
      setShrink(true);
      reset({
        ...editRadioBase,
      } as any);
    }
  }, [editRadioBase]);


  return <SingleFormBoxScene
    titlePage={titlePage}
    onCancel={() => {
      navigate(ROUTER_PATHS.mantenimientoOperaciones.radioBasesNav);
    }}
    onSave={handleSubmit(onSave, () => {
      setAlert(true, 'Campos obligatorios', AlertSeverityEnum.error)
    })}
  >

    <Grid container justifyContent="center" alignItems="center">
      <Grid item {...gridSizeMdLg8}>
        <Grid item container spacing={3} justifyContent="space-between">


          <CustomTextField
            label="Nombre"
            name="nombre"
            control={form.control}
            defaultValue={form.getValues().nombre || ''}
            error={errors.nombre}
            helperText={errors.nombre?.message ?? ''}
          />
          <CustomTextField
            label="Direccion"
            name="direccion"
            control={form.control}
            defaultValue={form.getValues().direccion || ''}
            error={errors.direccion}
            helperText={errors.direccion?.message ?? ''}
          />

          <CustomTextField
            label="Coordenadas"
            error={errors.coordenadas}
            helperText={errors.coordenadas?.message}
            shrink={shrink}
            name='coordenadas'
            control={form.control}
          />
          <ModelStateSelect
            defaultValue={form.getValues().estado || ''}
            register={register('estado')}
            error={errors.estado}
            helperText={errors.estado?.message}
          />

        </Grid>
      </Grid>
    </Grid>
  </SingleFormBoxScene>


};

export default SaveRadioBase;
